export default "__VITE_ASSET__DWxoTjbo__"